import Actions                  from 'Redux/Actions';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';
import { AppUserRepository }    from 'Domain/Repositories';
import { message }              from 'antd';

export const createAppUserEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.createAppUserRequest.type),
    mergeMap(action => from(AppUserRepository.create(action.payload.formData))
      .pipe(
        mergeMap((appUser) => {
          message.success('AppUser wurde erfolgreich erstellt');
          return from([
            Actions.createAppUserSuccess({ appUser })
          ]);
        }),
        catchError(error => {
          return from([
            Actions.createAppUserFailure({ error }),
          ]);
        })
      )
    ),
  );
};
